export default "__VITE_ASSET__itSlrxho__"